import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./About.scss";
import { AppWrap, MotionWrap } from "../../wrapper";

import { urlFor, client } from "../../client";

const About = () => {

  const ORDER = [
    "Front End Developer",
    "Back End Developer",
    "UI/UX Consultant",
    "Product Owner",
  ];

  const sortByOrder = (a, b) => {
    const ia = ORDER.indexOf(a.title);
    const ib = ORDER.indexOf(b.title);
    return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
  };

  // create initial state
  const [abouts, setAbouts] = useState([]);

  // populate abouts state once everytime the component mounts
  useEffect(() => {
    // create query for expected data from sanity
    const query = '*[_type == "abouts"]';

    // fetch data and populate abouts with data
    client.fetch(query).then((data) => {
      setAbouts(data.sort(sortByOrder));
    });
  }, []);

  return (
    <>
      <h2 className="head-text">
        Turning Ideas Into <span>Scalable</span>
        <br />
        User-Focused <span>Applications</span>
      </h2>

      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: "tween" }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>
              {about.title}
            </h2>
            <p className="p-text" style={{ marginTop: 10 }}>
              {about.description}
            </p>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(About, "app__about"),
  "about",
  "app__whitebg"
);
